export default {"src":"/_next/static/media/37-icon.bc5b1a4c.svg","height":46,"width":28,"blurWidth":0,"blurHeight":0};